<template>
	<b-form-group>
		<b-input-group prepend="Búsqueda">
			<b-form-input
				autocomplete="off"
				v-model="searchInput"
				v-on:keyup.enter="manageGetLocations()"
				v-on:keyup.backspace="cleanSearchBar('backspace')"
				@input="manageGetLocations()"
				v-on:keyup.escape="cleanSearchBar"
			></b-form-input>
			<b-input-group-append>
				<b-button variant="primary" @click="manageGetLocations()">
					Buscar
				</b-button>
			</b-input-group-append>
		</b-input-group>
	</b-form-group>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { getUserData } from '@/auth/utils'
import swal from 'sweetalert2'
import {
	BFormInput,
	BFormGroup,
	BInputGroupAppend,
	BInputGroup,
	BButton,
} from 'bootstrap-vue'
export default {
	components: {
		BFormGroup,
		BFormInput,
		BInputGroupAppend,
		BInputGroup,
		BButton,
	},
	data() {
		return {
			userData: getUserData(),
		}
	},
	computed: {
		searchInput: {
			set(value) {
				this.setInput(value)
			},
			get() {
				return this.$store.state.tableFilters.searchInput
			},
		},
	},
	methods: {
		manageGetLocations() {
			if(this.searchInput.length >= 3){
				this.$emit('getLocations')
			}
		},
		...mapMutations('tableFilters', ['setInput']),
		...mapActions('locations', ['getLocations']),
		cleanSearchBar(type = null) {
			if(type == null){
				console.log('asdasd')
				this.setInput(null)
				this.$emit('getLocations')
			}else{
				if(this.searchInput.length == 0){
					this.setInput(null)
					this.$emit('getLocations')
				}
			}
		},
	},
}
</script>

